// Импортируем другие js-файлы
jQuery(function($){

	$(document).ready(function($){

		$('#navBurger').click(function() {
			$(this).toggleClass('active');
			$('.nav__overlay').toggleClass('open');
		});

		var
			winHeight = $(window).height(),
			winWidth = $(window).width()

		$('.ourservices__content:not(.active)').slideUp()

		$('.ourservices__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.ourservices__tab')
			$('.ourservices__tab').removeClass('active')
			$('.ourservices__content').removeClass('active').slideUp()
			$(this).addClass('active')
			$('.ourservices__content:eq(' + n + ')').addClass('active').slideDown()
			$('.ourservices__content:eq(' + n + ') .ourservices__item').removeClass('active').slideUp()
			$('.ourservices__content:eq(' + n + ') .ourservices__item:eq(2)').addClass('active').slideDown()
			$('.ourservices__content:eq(' + n + ') .ourservices__name').removeClass('active')
			$('.ourservices__content:eq(' + n + ') .ourservices__name:eq(2)').addClass('active')
		})

		$('.ourservices__item:not(.active)').slideUp()

		$('.ourservices__name').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.ourservices__name')
			$('.ourservices__name').removeClass('active')
			$('.ourservices__item').removeClass('active').slideUp()
			$(this).addClass('active')
			$('.ourservices__item:eq(' + n + ')').addClass('active').slideDown()
		})

		let successesCarousel = $('.successes__carousel')
		successesCarousel.addClass('owl-carousel')
		
		successesCarousel.owlCarousel({
			items: 1,
			loop: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navContainer: '.successes__nav',
			mouseDrag: true,
			touchDrag: true,
			autoplay:true,
			autoplayTimeout: 4000,
			autoplayHoverPause:true,
			onInitialized: successes,
			onTranslated: successes
		})

		function successes(event) {
			let item = successesCarousel.find('.owl-item.active')
			let srcgrab = item.find('.successes__slide > img').attr('src')
			$('.successes__images').css('background-image', 'url(' + srcgrab + ')')

			//установка по умолчанию при клике
			let n = item.find('.successes__slide').attr('index')
			$('#successesTab' + n + '0').addClass('active')
			$('#successesContent' + n + '0').addClass('active').slideDown()
		}

		$('.successes__content:not(.active)').slideUp()

		let successesSlide = $('.successes__slide')

		successesSlide.each(function (i) {
			$(this).attr('id', 'successesSlide' + i).attr('index', '' + i)

			let successesTab = $(this).find('.successes__tab')
			successesTab.each(function (t) {
				$(this).attr('id', 'successesTab' + i + t).attr('index', '' + i + t)
			})

			let successesContent = $(this).find('.successes__content')
			successesContent.each(function (c) {
				$(this).attr('id', 'successesContent' + i + c).attr('index', '' + i + c)
			})
		
		})

		$('.successes__tab').on('click', function(e) {
			e.preventDefault()
			let id = $(this).attr('id')
			let n = $(this).attr('index')
			//console.log('id - ' + id)
			//console.log('index - ' + n)
			$('.successes__tab').removeClass('active')
			$('.successes__content').removeClass('active').slideUp()
			$('#' + id).addClass('active')
			$('#successesContent' + n).addClass('active').slideDown()
		})

		if($(window).width() < 1400) {
			$('.bestspecialists__line').addClass('owl-carousel')
			$('.bestspecialists__line').owlCarousel({
				loop: true,
				rewind: true,
				dots: false,
				nav: true,
				navText: ['<span><</span>','<span>></span>'],
				mouseDrag: true,
				touchDrag: true,
				autoplay:true,
				autoplayTimeout: 5000,
				autoplayHoverPause:true,
				responsive: {
					0 : {
						items: 1,
						nav: false
					},
					500 : {
						items: 2,
					},
					700 : {
						items: 3,
					},
					1000 : {
						items: 4,
					},
					1200 : {
						items: 5,
					},
					1400 : {
						items: 5,
					}
				}
			})
		}

		let digitalsphereCarousel = $('.digitalsphere__carousel')
		
		digitalsphereCarousel.owlCarousel({
			items: 1,
			loop: true,
			responsiveClass: true,
			dots: true,
			dotsContainer: '.digitalsphere__dots',
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '.digitalsphere__navs',
			mouseDrag: true,
			touchDrag: true,
			onInitialized: function(e) {
				let size = e.page.size
				let pages = Math.ceil(this.items().length / size)
				//console.log('page - ' + pages)
				for(i = 0; i <= pages; i++) {
					$('.digitalsphere__dots .owl-dot:eq(' + i + ') span').html(i + 1)
				}
			},
		})

		$('.talk__socbtn').on('click', function(e) {
			e.preventDefault()
			$('.talk__socbtn').removeClass('active')
			$(this).addClass('active')
		})

		let reviewsCarousel = $('.reviews__carousel')
		
		reviewsCarousel.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '.reviews__nav',
			mouseDrag: true,
			touchDrag: true,
			autoplay:true,
			autoplayTimeout: 2000,
			autoplayHoverPause:true,
			onDragged: reviewsCallback,
			onTranslated: reviewsCallback
		})

		$('.reviews__carousel .owl-item.center').next().addClass("next")
		$('.reviews__carousel .owl-item.center').prev().addClass("prev")

		function reviewsCallback(e) {

			$('.reviews__carousel .owl-item').removeClass("next")
			$('.reviews__carousel .owl-item').removeClass("prev")
			
			$('.reviews__carousel .owl-item.center').next().addClass("next")
			$('.reviews__carousel .owl-item.center').prev().addClass("prev")

			//$('.reviews__carousel .owl-item.center').nextAll().addClass("next")
			//$('.reviews__carousel .owl-item.center').prevAll().addClass("prev")
			
		}

		$('.devservice__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.devservice__tab')
			$('.devservice__tab').removeClass('active')
			$('.devservice__content').removeClass('active')
			$(this).addClass('active')
			$('.devservice__content:eq(' + n + ')').addClass('active')
		})
		
		$('.experience__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.experience__tab')
			$('.experience__tab').removeClass('active')
			$('.experience__content').removeClass('active')
			$(this).addClass('active')
			$('.experience__content:eq(' + n + ')').addClass('active')
		})

		$('.threecomponents__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.threecomponents__tab')
			$('.threecomponents__tab').removeClass('active')
			$('.threecomponents__content').removeClass('active')
			$(this).addClass('active')
			$('.threecomponents__content:eq(' + n + ')').addClass('active')
		})

		$('.servicepack__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.servicepack__tab')
			$('.servicepack__tab').removeClass('active')
			$('.servicepack__content').removeClass('active')
			$(this).addClass('active')
			$('.servicepack__content:eq(' + n + ')').addClass('active')
		})

		let clientresultsCarousel = $('.clientresults__carousel')
		clientresultsCarousel.addClass('owl-carousel')
		
		clientresultsCarousel.owlCarousel({
			items: 1,
			loop: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navContainer: '.clientresults__navs',
			mouseDrag: true,
			touchDrag: true,
			onInitialized: clientresults,
			onTranslated: clientresults
		})

		function clientresults(event) {
			let item = clientresultsCarousel.find('.owl-item.active')
			let srcgrab = item.find('.clientresults__slide > img').attr('src')
			$('.clientresults__images').css('background-image', 'url(' + srcgrab + ')')
		}

		// -------------- devresourseSlider ------------
		let devresourseSlider = $('.devresourse__slider')
		devresourseSlider.each(function (i) {
			$(this).attr('id', 'devresourseSlider' + i);
			$(this).find('.devresourse__navs').attr('id', 'devresourseNavs' + i);
			$('#devresourseSlider' + i + ' .devresourse__carousel').owlCarousel({
				items: 1,
				loop: true,
				rewind: true,
				dots: false,
				nav: true,
				navContainer: '#devresourseNavs' + i
			})
		})

		$('.devresourse__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.devresourse__tab')
			$('.devresourse__tab').removeClass('active')
			$('.devresourse__content').removeClass('active')
			$(this).addClass('active')
			$('.devresourse__content:eq(' + n + ')').addClass('active')
		})

		$('#devresourseBtn').on('click', function(e) {
			e.preventDefault()
			$('body').toggleClass('shadow')
			$('#devresoursePictures').toggleClass('open')
		})

		$('.devresourse__pictures').on('click', function(e) {
			e.preventDefault()
			$('body').removeClass('shadow')
			$('#devresoursePictures').removeClass('open')
		})

		// -------------- seoresultsCarousel1 ------------

		let seoresultsCarousel1 = $('#seoresultsCarousel1')
		
		seoresultsCarousel1.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '.seoresults__navs1',
			mouseDrag: true,
			touchDrag: true,
			onDragged: seoresultsCallback1,
			onTranslated: seoresultsCallback1
		})

		$('#seoresultsCarousel1 .owl-item.center').next().addClass("next")
		$('#seoresultsCarousel1 .owl-item.center').prev().addClass("prev")

		function seoresultsCallback1(e) {
			$('#seoresultsCarousel1 .owl-item').removeClass("next")
			$('#seoresultsCarousel1 .owl-item').removeClass("prev")
			$('#seoresultsCarousel1 .owl-item.center').next().addClass("next")
			$('#seoresultsCarousel1 .owl-item.center').prev().addClass("prev")
		}

		// -------------- seoresultsCarousel2 ------------

		let seoresultsCarousel2 = $('#seoresultsCarousel2')
		
		seoresultsCarousel2.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '.seoresults__navs2',
			mouseDrag: true,
			touchDrag: true,
			onDragged: seoresultsCallback2,
			onTranslated: seoresultsCallback2
		})

		$('#seoresultsCarousel2 .owl-item.center').next().addClass("next")
		$('#seoresultsCarousel2 .owl-item.center').prev().addClass("prev")

		function seoresultsCallback2(e) {
			$('#seoresultsCarousel2 .owl-item').removeClass("next")
			$('#seoresultsCarousel2 .owl-item').removeClass("prev")
			$('#seoresultsCarousel2 .owl-item.center').next().addClass("next")
			$('#seoresultsCarousel2 .owl-item.center').prev().addClass("prev")
		}

		// -------------- seoresultsCarousel3 ------------

		let seoresultsCarousel3 = $('#seoresultsCarousel3')
		
		seoresultsCarousel3.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '.seoresults__navs3',
			mouseDrag: true,
			touchDrag: true,
			onDragged: seoresultsCallback3,
			onTranslated: seoresultsCallback3
		})

		$('#seoresultsCarousel3 .owl-item.center').next().addClass("next")
		$('#seoresultsCarousel3 .owl-item.center').prev().addClass("prev")

		function seoresultsCallback3(e) {
			$('#seoresultsCarousel3 .owl-item').removeClass("next")
			$('#seoresultsCarousel3 .owl-item').removeClass("prev")
			$('#seoresultsCarousel3 .owl-item.center').next().addClass("next")
			$('#seoresultsCarousel3 .owl-item.center').prev().addClass("prev")
		}

		// -------------- seoresultsCarousel4 ------------

		let seoresultsCarousel4 = $('#seoresultsCarousel4')
		
		seoresultsCarousel4.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '.seoresults__navs4',
			mouseDrag: true,
			touchDrag: true,
			onDragged: seoresultsCallback4,
			onTranslated: seoresultsCallback4
		})

		$('#seoresultsCarousel4 .owl-item.center').next().addClass("next")
		$('#seoresultsCarousel4 .owl-item.center').prev().addClass("prev")

		function seoresultsCallback4(e) {
			$('#seoresultsCarousel4 .owl-item').removeClass("next")
			$('#seoresultsCarousel4 .owl-item').removeClass("prev")
			$('#seoresultsCarousel4 .owl-item.center').next().addClass("next")
			$('#seoresultsCarousel4 .owl-item.center').prev().addClass("prev")
		}

		// -------------- seoconclusionCarousel ------------
		let seoconclusionCarousel = $("#seoconclusionCarousel")

		seoconclusionCarousel.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '#seoconclusionNavs',
			mouseDrag: true,
			touchDrag: true,
			autoplay:true,
			autoplayTimeout: 2000,
			autoplayHoverPause:true,
		})

		// -------------- floralconclusionCarousel ------------
		let floralconclusionCarousel = $("#floralconclusionCarousel")

		floralconclusionCarousel.owlCarousel({
			items: 1,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '#floralconclusionNavs',
			mouseDrag: true,
			touchDrag: true,
			autoplay:true,
			autoplayTimeout: 2000,
			autoplayHoverPause:true,
		})

		// -------------- floralresourseSlider ------------
		let floralresourseSlider = $('.floralresourse__slider')
		floralresourseSlider.each(function (i) {
			$(this).attr('id', 'floralresourseSlider' + i);
			$(this).find('.floralresourse__navs').attr('id', 'floralresourseNavs' + i);
			$('#floralresourseSlider' + i + ' .floralresourse__carousel').owlCarousel({
				items: 1,
				loop: true,
				rewind: true,
				dots: false,
				nav: true,
				navContainer: '#floralresourseNavs' + i
			})
		})

		$('.floralresourse__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.floralresourse__tab')
			$('.floralresourse__tab').removeClass('active')
			$('.floralresourse__content').removeClass('active')
			$(this).addClass('active')
			$('.floralresourse__content:eq(' + n + ')').addClass('active')
		})

		$('#floralresourseBtn').on('click', function(e) {
			e.preventDefault()
			$('body').toggleClass('shadow')
			$('#floralresoursePictures').toggleClass('open')
		})

		$('.floralresourse__pictures').on('click', function(e) {
			e.preventDefault()
			$('body').removeClass('shadow')
			$('#floralresoursePictures').removeClass('open')
		})

		// -------------- floralresourseSlider ------------
		let floralresourseImgcarousel = $('#floralresourseImgcarousel')
		
		floralresourseImgcarousel.owlCarousel({
			items: 3,
			loop: true,
			margin: 0,
			center: true,
			responsiveClass: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			navContainer: '#floralresourseImgnavs',
			mouseDrag: true,
			touchDrag: true,
			autoplay:true,
			autoplayTimeout: 2000,
			autoplayHoverPause:true,
			onDragged: floralresourseCallback,
			onTranslated: floralresourseCallback
		})

		$('#floralresourseImgcarousel .owl-item.center').next().addClass("next")
		$('#floralresourseImgcarousel .owl-item.next').next().addClass("fornext")
		$('#floralresourseImgcarousel .owl-item.center').prev().addClass("prev")
		$('#floralresourseImgcarousel .owl-item.prev').prev().addClass("forprev")

		function floralresourseCallback(e) {

			$('#floralresourseImgcarousel .owl-item').removeClass("next")
			$('#floralresourseImgcarousel .owl-item').removeClass("fornext")
			$('#floralresourseImgcarousel .owl-item').removeClass("prev")
			$('#floralresourseImgcarousel .owl-item').removeClass("forprev")
			
			$('#floralresourseImgcarousel .owl-item.center').next().addClass("next")
			$('#floralresourseImgcarousel .owl-item.next').next().addClass("fornext")
			$('#floralresourseImgcarousel .owl-item.center').prev().addClass("prev")
			$('#floralresourseImgcarousel .owl-item.prev').prev().addClass("forprev")
			
		}

		// -------------- floralspecificSlider ------------
		let floralspecificSlider = $('.floralspecific__slider')
		floralspecificSlider.each(function (i) {
			$(this).attr('id', 'floralspecificSlider' + i)
			$(this).find('.floralspecific__carousel').attr('id', 'floralspecificCarousel' + i)
			$(this).find('.floralspecific__navs').attr('id', 'floralspecificNavs' + i)

			$('#floralspecificCarousel' + i).owlCarousel({
				items: 1,
				loop: false,
				rewind: true,
				dots: false,
				nav: true,
				navText: ['<span><</span>','<span>></span>'],
				navContainer: '#floralspecificNavs' + i
			})
		})

		// -------------- portfoliotype ------------

		$('.portfoliotype__tab').on('click', function(e) {
			e.preventDefault()
			let n = $(this).index('.portfoliotype__tab')
			$('.portfoliotype__tab').removeClass('active')
			$('.portfoliotype__content').removeClass('active')
			$(this).addClass('active')
			$('.portfoliotype__content:eq(' + n + ')').addClass('active')
		})

		// -------------- certification ------------

		$('.certification__slider').owlCarousel({
			loop: true,
			rewind: true,
			dots: false,
			nav: true,
			navText: ['<span><</span>','<span>></span>'],
			mouseDrag: true,
			touchDrag: true,
			autoplay:true,
			autoplayTimeout: 5000,
			autoplayHoverPause:true,
			responsive: {
				0 : {
					items: 1,
					margin: 0
				},
				1000 : {
					items: 2,
					margin: 60
				}
			}
		})
		

		// -------------- initialize ------------

		function initialize() {

			let docHeight = $(window).height()
			let docWidth = $(window).width()

			let el = $('.header__top'),
			sH = el.outerHeight(),
			sc = $('.scroll')

			if (docWidth > 1100) {
				if($(this).scrollTop() >= sH) {
					sc.addClass('open')
				}
				if($(this).scrollTop() < sH) {
					sc.removeClass('open')
				}
			} else {
				sc.removeClass('open')
			}

			$(window).on('scroll', function() {
				if (docWidth > 780) {
					if($(this).scrollTop() >= sH) {
						sc.addClass('open')
					}
					if($(this).scrollTop() < sH) {
						sc.removeClass('open')
					}
				} else {
					sc.removeClass('open')
				}
			})

			let floralprototypeGrid = $('.floralprototype__grid')
			if($(window).width() <= 500) {
				floralprototypeGrid.addClass('owl-carousel')
				floralprototypeGrid.owlCarousel({
					items: 1,
					loop: true,
					rewind: true,
					dots: false,
					nav: false,
					mouseDrag: true,
					touchDrag: true,
					autoplay:true,
					autoplayTimeout: 5000,
					autoplayHoverPause:true
				})
			} else {
				floralprototypeGrid.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
				floralprototypeGrid.find('.owl-stage-outer').children().unwrap();
			}

		}

		initialize()

		// initilize after window resize
		var id
		$(window).resize(function() {
			clearTimeout(id);
			id = setTimeout(initialize, 500)
		})

	})

})